import { MediaSummaryCard, type MediaSummaryView } from '../MediaSummaryCard/MediaSummaryCard';
import type { WidgetBlockProps } from '../shared/cardShell';

export type MediaTotalMentionsCardProps = WidgetBlockProps & { view?: MediaSummaryView };

/** Figma `2123:83787` — `mentions` over coverage rows. */
export function MediaTotalMentionsCard(props: MediaTotalMentionsCardProps) {
  return (
    <MediaSummaryCard
      {...props}
      title="Total mentions"
      helpText="Every story a media outlet published about your brand in the period."
      helpSupportingText="Earned media only: a reader's post or reply has no publisher and is not counted. Overview's Total mentions counts every mention; this is the published slice of it."
    />
  );
}
